export const RealtimeHealthStatus = {
    CONNECTING: "connecting",
    HEALTHY: "healthy",
    WARNING: "warning",
    DEAD: "dead",
};